/// <amd-module name="Pipeline/Analytics/PipelineStepsDurationCard/Common/StackedColumnChartDataHelper" />
import { adjustDataForAllPeriod, IDataForDate } from "Analytics/Shared/Common/Utils/DateAdjuster";
import { ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { getStackedColumnChartData } from "Pipeline/Analytics/Common/ChartHelper/StackedColumnChartDataSelector";
import { colors } from "Pipeline/Analytics/Common/Constants";
import { maxItemsToShowInCharts } from "Pipeline/Analytics/Common/Constants";
import * as TelemetryConstants from "Pipeline/Analytics/Common/Telemetry/TelemetryConstants";
import { IAnalyticsChartProps } from "Pipeline/Analytics/Common/Types";
import * as Resources from "Pipeline/Analytics/PipelineStepsDurationCard/Resources";
import { IPipelineStepDurationTrend, IStepDurationData, IStageStepsDurationData } from "Pipeline/Analytics/PipelineStepsDurationCard/Types";
import { ChartProps } from "VSS/Features/Charts/Contracts";
import { DataPoint, TooltipLineItem } from "VSS/Features/Charts/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";

interface IStepTODate {
    dailyDurationData: { [date: string]: number };
}

export function getStackedColumnChartProps(
    pageContext: IVssPageContext,
    data: IPipelineStepDurationTrend[],
    stageName: string,
    topStepDurationData: IStageStepsDurationData,
    configuration?: ITrendChartReportConfiguration
): ChartProps {
    let adjustableData = data.map((value: IPipelineStepDurationTrend) => {
        return {
            date: value.date,
            data: value.stepsDurationData[stageName]
        } as IDataForDate<IStepDurationData[]>;
    });

    adjustableData = adjustDataForAllPeriod(
        adjustableData,
        configuration ? configuration.trendBy : undefined,
        configuration ? configuration.period : undefined,
        undefined
    );
    const adjustedValues = adjustableData.map(datum => datum.date);

    let topDurationStepNames: { [stepName: string]: {} } = {};
    topStepDurationData.stepDurationData[stageName].stepsData.slice(0, maxItemsToShowInCharts).map(step => {
        topDurationStepNames[step.stepName] = {};
    });

    const stepToDataMap: { [stepName: string]: IStepTODate } = {};
    adjustableData.forEach(datum => {
        if (datum.data) {
            datum.data.forEach(stepDurationData => {
                if (topDurationStepNames[stepDurationData.stepName]) {
                    if (!stepToDataMap[stepDurationData.stepName]) {
                        stepToDataMap[stepDurationData.stepName] = {
                            dailyDurationData: {}
                        };
                    }
                    stepToDataMap[stepDurationData.stepName].dailyDurationData[datum.date] = stepDurationData.stepDuration;
                }
            });
        }
    });

    let i = 0;
    const series = Object.keys(topDurationStepNames).map(stepName => {
        return {
            name: stepName,
            data: adjustedValues.map(date => (stepToDataMap[stepName] && stepToDataMap[stepName].dailyDurationData[date]) || null),
            color: colors[i++]
        };
    });

    const chartData = {
        title: Resources.PipelineDurationTrendChart,
        xAxisLabelValues: adjustedValues,
        yAxisTitle: Resources.StepDurationText,
        series: series,
        telemetryArea: TelemetryConstants.feature_PipelineStepsDurationCard
    } as IAnalyticsChartProps;
    return getStackedColumnChartData(pageContext, chartData);
}

export function setCustomTooltipMapping(chartProps: ChartProps, tooltipMapping: (points: DataPoint[]) => TooltipLineItem[]) {
    chartProps.tooltip = {
        customTooltipMapping: tooltipMapping
    };
    return chartProps;
}
